import React, { useEffect, useState } from "react";
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { PaginationType } from "../../../types/common-type"; 
import { useNavigate, useParams } from "react-router";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import { 
  formattedDate,
} from "../../../core/methods/formattedDate";
import Loading from "../../../core/common/custom-loading/Loading";
import { exportAntdTableToExcel } from "../../utils/exportExcel";
import {
  safeDateSort,
  safeNumberSort,
  safeStringSort,
} from "../../../core/methods/sorterMethods";
import { ColumnsType } from "antd/es/table";
import { getSearchableHeader } from "../../utils/getSearchableHeader";
import { filterByColumnSearch } from "../../utils/filterByColumnSearch"; 
import Datatable from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";

const InvalidCandidates = () => {
  const { orderId } = useParams();
  const [allItemList, setAllItemList] = useState<any[]>([]); 
  const [pagination, setPagination] = useState<PaginationType>({
    current: 1,
    pageSize: 10, // limit of records
    total: 0,
  });
  const navigate = useNavigate();

  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});

  const { callApi: getValidApi, loading: loadingValid } = useApi<any>("", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const filteredData = filterByColumnSearch(
    Array.isArray(allItemList) ? allItemList : [],
    inventoryColumnSearch,
  );

  const handleReviewCandidate = (candidate: any) => {
    navigate(all_routes.updateInvalidCandidate, {
      state: { candidate , orderId},
    });
  };

  const fetchValidData = async (current: number, limit: number) => {
    try {
      const res = await getValidApi(
        {
          page: current,
          limit: limit,
        },
        `${webservice_url.getInvalidCandidateByOrder}/${orderId}`,
      );

      const data = res?.data || null;
      if (!data) return;

      setAllItemList(Array.isArray(data?.candidates) ? data?.candidates : []);
      setPagination({
        current: data?.pagination?.page,
        pageSize: data?.pagination?.limit,
        total: data?.pagination?.total,
      });
    } catch (err: any) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (!orderId) return;
    fetchValidData(pagination?.current, pagination?.pageSize);
  }, [orderId]);

  //   handle table change
  const handleTableChange = (pgConfig: any) => {
    if (
      pgConfig.current !== pagination.current ||
      pgConfig.pageSize !== pagination.pageSize
    ) {
      fetchValidData(pgConfig.current, pgConfig.pageSize);
    }
  };

  // table column
  const columns: ColumnsType<any> = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      onCell: () => cellWidth(100),
      render: (text: string, record: any, index: number) => index + 1,
      sorter: false,
      excelFormatter: (text: string, record: any, index: number) => index + 1,
    } as any,
    {
      title: getSearchableHeader(
        "Candidate Name",
        "full_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "full_name",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.full_name, b.full_name),
    },
    {
      title: getSearchableHeader(
        "Applicant Mobile Number",
        "phone",
        setInventoryColumnSearch,
      ),
      dataIndex: "phone",
      onCell: () => cellWidth(160),
      render: (value: any) => value || "-",
      sorter: (a, b) => safeNumberSort(a.phone, b.phone),
    },
    {
      title: getSearchableHeader(
        "Applicant Email Id",
        "email",
        setInventoryColumnSearch,
      ),
      dataIndex: "email",
      onCell: () => cellWidth(160),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.email, b.email),
    },
    {
      title: getSearchableHeader(
        "Applicant Registration Number/CRN",
        "crn",
        setInventoryColumnSearch,
      ),
      dataIndex: "crn",
      onCell: () => cellWidth(240),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.crn, b.crn),
    },
    {
      title: getSearchableHeader(
        "Applicant Employee Id/Code",
        "employee_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "employee_id",
      onCell: () => cellWidth(200),
      render: (text: any) => text || "-",
      sorter: (a, b) => safeStringSort(a.employee_id, b.employee_id),
    },
    {
      title: getSearchableHeader(
        "Joining Date",
        "joining_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "joining_date",
      onCell: () => cellWidth(160),
      render: (text: any) => {
        return <div>{text ? formattedDate(text) : "-"}</div>;
      },
      sorter: (a: any, b: any) => safeDateSort(a.joining_date, b.joining_date),
      excelFormatter: (text: string) => formattedDate(text) || "-",
    } as any,

    {
      title: "Action",
      key: "action",
      width: 120,
      render: (_: any, record: any) => (
        <button
          type="button"
          className="btn btn-sm btn-primary"
          // onClick={() => setSelectedCandidate(record)}
          onClick={() => handleReviewCandidate(record)}
        >
          <i className="ti ti-eye me-1" />
          Review
        </button>
      ),
    },
  ];

  // handleDownloadExcel
  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: allItemList,
      fileName: "invalid_candidate_Report",
      sheetName: "Invalid Candidates",
    });
  };

  return (
    <>
      <div className="mt-3 px-3 px-md-0">
        {/* Download Excel Button */}
        <div className="text-end">
          <button
            className="btn btn-sm btn-primary"
            onClick={handleDownloadExcel}
            disabled={loadingValid}
          >
            <i className="bi bi-download pe-2"></i>
            Export to Excel
          </button>
        </div>

        {loadingValid ? (
          <Loading />
        ) : (
          <div className="mt-3">
            {/* Table */}
            <Datatable
              dataSource={filteredData}
              columns={columns}
              Selection={false}
              // hideSizeChanger={true}
              fixedHeader
              tableHeight={650}
              pagination={pagination}
              handleTableChange={handleTableChange}
            />
          </div>
        )}
      </div>

      {/* {selectedCandidate && (
        <ReviewCandidateModal
          candidate={selectedCandidate}
          onClose={() => setSelectedCandidate(null)}
          onConfirm={(updatedCandidate) => {
            // Frontend validation is complete.
            // Connect the real backend conversion API here.
            console.log("Candidate ready for validation:", updatedCandidate);
          }}
        />
      )} */}
    </>
  );
};

export default InvalidCandidates;
